<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Manage Inspection Types</h1>

      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="name"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.name.value"
              />
              <label>Name</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="description"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.description.value"
              />
              <label>Description</label>
            </span>
          </div>

          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter(dataTable)"></button>
          </div>
        </div>
      </form>

      <p-table
        #dataTable
        selectionMode="single"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        resizableColumns="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        (onRowSelect)="onRowSelect($event)"
        [hidden]="!isLoaded"
        [(selection)]="selectedItem"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Name</th>
            <th pSortableColumn="description">Description</th>
            <th>Active</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="onRowDblclick(item)" [pSelectableRow]="item">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              <p-checkbox [(ngModel)]="item.isActive" binary="true" [disabled]="true"> </p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
      <p-dataTabl #dataTable selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                   [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)" (onRowDblclick)="onRowDblclick($event)" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                   [hidden]="!isLoaded" [(selection)]="selectedItem">
          <p-column field="name" header="Name" [sortable]="tru" [editable]="false" [style]="{'width': '45%'}"></p-column>
          <p-column field="description" header="Description" [sortable]="tru" [editable]="false" [style]="{'width': '45%'}"></p-column>
          <p-column field="isActive" header="Active" [sortable]="tru" [editable]="false" [style]="{'width': '10%'}">
              <ng-template let-row="rowData" let-index="rowIndex" let-col pTemplate="body">
                  <p-checkbox [(ngModel)]="row[col.field]" binary="true" [disabled]="true"> </p-checkbox>
              </ng-template>
          </p-column>
      </p-dataTable>
      --->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          pButton
          (click)="onEdit()"
          label="Edit"
          icon="fa ui-icon-mode-edit"
          [disabled]="!selectedItem"
        ></button>
        <button
          type="button"
          class="btn-to-right"
          pButton
          icon="fa ui-icon-add"
          (click)="showDialogToAdd()"
          label="Add"
        ></button>
      </div>

      <p-dialog
        header="Inspection Type"
        [(visible)]="displayDialog"
        [responsive]="true"
        [modal]="true"
        [style]="{ width: '400px' }"
      >
        <form
          [formGroup]="newInspectionTypeForm"
          (ngSubmit)="save(newInspectionTypeForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid" *ngIf="inspection">
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="name">Name</label></div>
              <div class="ui-g-8">
                <input pInputText id="name" formControlName="name" maxlength="50" />
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="description">Description</label></div>
              <div class="ui-g-8">
                <textarea
                  pInputTextarea
                  id="description"
                  formControlName="description"
                  maxlength="255"
                ></textarea>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-4"><label for="isactive">Active</label></div>
              <div class="ui-g-8">
                <p-checkbox name="isActive" binary="true" formControlName="isActive"></p-checkbox>
              </div>
            </div>
          </div>

          <div style="float: right">
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="newInspectionTypeForm.invalid"
            ></button>
            <button
              type="button"
              pButton
              icon="fa ui-icon-close"
              label="Cancel"
              (click)="close()"
            ></button>
          </div>
        </form>
      </p-dialog>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
